import { ActionsObservable } from 'redux-observable';
import { Store } from 'redux';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/throw';
import 'rxjs/add/observable/fromPromise';
import 'rxjs/add/operator/catch';
import { catchError } from 'rxjs/operators';
import { AjaxCreationMethod } from 'rxjs/observable/dom/AjaxObservable';
import {
  AuthRequest,
  AppAction,
  authSuccess,
  logoutSuccess,
  authPopupCloseSuccess,
  LoginWithToken,
  resetMessageState,
  LoginWithQueryParam,
} from '../actions';
import { AUTH_REQUEST, AUTH_POPUP_CLOSE, LOGOUT_REQUEST, LOGIN_WITH_TOKEN,
   LOGIN_WITH_QUERY_PARAM } from '../constants';
import { AppState } from '../models';
import { default as userManager } from '../utils/userManager';
import { User } from 'oidc-client';
import { push } from 'react-router-redux';

export const authRequest = (action$: ActionsObservable<AppAction>,
                            store: Store<AppState>,
                            ajax: AjaxCreationMethod): Observable<AppAction> => {
  return action$.ofType(AUTH_REQUEST)
    .mergeMap((authRequest: AuthRequest) => {
      const promise = userManager.signinPopup({ acr_values: `idp:${authRequest.provider}` });
      return Observable.fromPromise(promise).mergeMap
        ((user: User) => {
          return [
            resetMessageState(),
            authSuccess(user.profile.uid,
                        user.access_token,
                        user.profile.idp,
                        user.profile.queues,
                        user.profile.name),
            push('/home'),
          ];
        });
    });

};

export const authPopupClose = (action$: ActionsObservable<AppAction>,
                               store: Store<AppState>,
                               ajax: AjaxCreationMethod): Observable<AppAction> => {
  return action$.ofType(AUTH_POPUP_CLOSE)
    .mergeMap((authRequest: AuthRequest) => {
      return Observable.fromPromise(userManager.signinPopupCallback())
        .map((d) => {
          window.close();
          return authPopupCloseSuccess();
        });
    });

};

export const logoutRequest = (action$: ActionsObservable<AppAction>,
                              store: Store<AppState>,
                              ajax: AjaxCreationMethod): Observable<AppAction> => {
  return action$.ofType(LOGOUT_REQUEST)
    .mergeMap((authRequest: AuthRequest) => {
      const promise = userManager.removeUser();
      return Observable.fromPromise(promise).mergeMap
        (() => {
          return [resetMessageState(), logoutSuccess(), push('/')];
        });
    });

};



export const loginWithToken = (action$: ActionsObservable<AppAction>,
                               store: Store<AppState>,
                               ajax: AjaxCreationMethod): Observable<AppAction> => {
  return action$.ofType(LOGIN_WITH_TOKEN)
    .mergeMap((req: LoginWithToken) => {
      return Observable.of(true).mergeMap
        (() => {
          return [
            resetMessageState(),
            authSuccess(req.expertId,
                        req.token,
                        '',
                        [],
                        ''),
            push('/home'),
          ];
        });
    });
};

export const loginWithQueryString = (action$: ActionsObservable<AppAction>,
                                     store: Store<AppState>,
                                     ajax: AjaxCreationMethod): Observable<AppAction> => {
  return action$.ofType(LOGIN_WITH_QUERY_PARAM)
    .mergeMap((loginWithQueryParam: LoginWithQueryParam) => {
      
      const promise = userManager.signinSilent();
      return Observable.fromPromise(promise).mergeMap
        ((user: User) => {
          return [
            resetMessageState(),
            authSuccess(user.profile.uid,
                        user.access_token,
                        user.profile.idp,
                        user.profile.queues,
                        user.profile.name),
            push('/home'),
          ];
        }).pipe(
         catchError(() => Observable.of(push('/'))),
        );
    });
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/epics/auth.ts